import { formatDate, formatDateLong, FUSO_BRASILIA } from '@/shared/formatters/date';

/**
 * Todo instante desta feature é um MARCO do processo, e por isso é lido no fuso de Brasília,
 * nunca no do runtime: o `vencimentoAt` do guard é o fim do dia civil em São Paulo
 * (23:59:59.999), que em UTC cai no DIA SEGUINTE. Sem `timeZone`, o SSR (UTC na Vercel) e
 * qualquer máquina fora do BRT renderizam a data posterior — a tela diz que o prazo vence em
 * 10/02 quando ele venceu em 09/02, e o operador segura ou publica o trânsito pela data errada.
 *
 * São os formatadores de `shared/` sob outro nome, e não cópias: a regra de fuso mora em um
 * lugar só (`FUSO_BRASILIA`).
 */
export const formatarData = formatDate;

export const formatarDataExtenso = formatDateLong;

export function formatarDataHora(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', {
    timeZone: FUSO_BRASILIA,
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function rotuloDiasRestantes(dias: number): string {
  if (dias < 0) {
    const vencidos = Math.abs(dias);
    return vencidos === 1 ? 'Venceu ontem' : `Vencido há ${vencidos} dias`;
  }
  if (dias === 0) return 'Vence hoje';
  if (dias === 1) return 'Falta 1 dia';
  return `Faltam ${dias} dias`;
}

export function formatarTamanho(bytes: number | null): string | null {
  if (bytes === null) return null;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
